module.exports = __webpack_public_path__ + "static/assets/7f018aaa2d4f794168343e30de5944f3.png";